import cs from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useEffect, useState, useRef } from 'react';
import './header-container.scss';

function closeModalOutsideTrigger(ref, setActive) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
}



const HeaderContainer = (props) => {
  const [isActive, setActive] = useState(false);
  const [searchToggle, setSearchToggle] = useState(false);
  const [resourcesToggle, setResourcesToggle] = useState(false);
  const [testimonialsToggle, setTestimonialsToggle] = useState(false);

  const toggleAllFalse = () => {
    setSearchToggle(false);
    setResourcesToggle(false);
    setTestimonialsToggle(false);
  };

  const toggleClass = () => {
    setActive(!isActive);
  };

  const toggleSearch = () => {
    toggleAllFalse();
    setSearchToggle(!searchToggle);
  };

  const toggleTestimonials = () => {
    toggleAllFalse();
    setTestimonialsToggle(!testimonialsToggle);
  };

  const toggleResources = () => {
    toggleAllFalse();
    setResourcesToggle(!resourcesToggle);
  };

  const wrapperRef = useRef(null);
  closeModalOutsideTrigger(wrapperRef, setActive);

  return (
    <div className={cs('on-title-header')} ref={wrapperRef}>
      <div>
        <header id="top" className="js-header-top">
          <nav className="bt-navbar js-hub">
            <div className="container bt-navbar__container">
              <div className="bt-navbar__left">
                <ul id="menu-main-menu" className="uk-subnav">
                  <li className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item ">
                    <a
                      className="menu-list__link"
                      href="https://www.strockrealestate.com/"
                    >
                      Home
                    </a>
                  </li>
                  <li
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children bt-ccomp"
                    data-bt-ccomp="dropdown"
                    onClick={toggleSearch}
                  >
                    <a
                      className="menu-list__link"
                      href="#"
                      data-bt-ccomp-trigger=""
                    >
                      Search
                      <svg
                        viewBox="0 0 7.798 4.548"
                        id="bicon-arrow-down"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M7.15 0a.25.25 0 0 1 .18.078l.39.39a.25.25 0 0 1 .078.18.24.24 0 0 1-.078.18L4.08 4.47a.246.246 0 0 1-.36 0L.077.83A.247.247 0 0 1 .078.47l.39-.392A.255.255 0 0 1 .65 0c.07 0 .13.026.18.078l3.07 3.07L6.97.078A.247.247 0 0 1 7.15 0z"></path>
                      </svg>
                    </a>
                    <div className="bt-ccomp__content "
                      style={{ display: searchToggle ? "block" : "none" }}
                    >
                      <ul className="menu-list level-0">
                        <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                          <a className="menu-list__link" href="https://www.strockrealestate.com/results-gallery/">
                            Search
                          </a>
                        </li>
                        <li className="menu-item menu-item-type-post_type menu-item-object-page ">
                          <a
                            className="menu-list__link"
                            href="https://www.strockrealestate.com/results-map/"
                          >
                            Map Search
                          </a>
                        </li>
                        <li className="menu-item menu-item-type-post_type menu-item-object-page ">
                          <a
                            className="menu-list__link"
                            href="https://www.strockrealestate.com/results-gallery/"
                          >
                            Our Listings
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children bt-ccomp"
                    data-bt-ccomp="dropdown"
                  >
                    <a
                      className="menu-list__link"
                      href="https://www.strockrealestate.com/buy"
                      data-bt-ccomp-trigger=""
                    >
                      Buying
                    </a>

                  </li>
                  <li
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children bt-ccomp"
                    data-bt-ccomp="dropdown"
                  >
                    <a
                      className="menu-list__link"
                      href="https://www.strockrealestate.com/finance"
                      data-bt-ccomp-trigger=""
                    >
                      Financing
                    </a>
                  </li>
                  <li
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children bt-ccomp"
                    data-bt-ccomp="dropdown"
                  >
                    <a
                      className="menu-list__link"
                      target="_blank"
                      href="https://www.strockrealestate.com/sell"
                      data-bt-ccomp-trigger=""
                    >
                      Selling
                    </a>
                  </li>
                  <li
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children bt-ccomp"
                    data-bt-ccomp="dropdown"
                    onClick={toggleResources}
                  >
                    <a
                      className="menu-list__link"
                      target="_blank"
                      data-bt-ccomp-trigger=""
                    >
                      Resources
                      <svg
                        viewBox="0 0 7.798 4.548"
                        id="bicon-arrow-down"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M7.15 0a.25.25 0 0 1 .18.078l.39.39a.25.25 0 0 1 .078.18.24.24 0 0 1-.078.18L4.08 4.47a.246.246 0 0 1-.36 0L.077.83A.247.247 0 0 1 .078.47l.39-.392A.255.255 0 0 1 .65 0c.07 0 .13.026.18.078l3.07 3.07L6.97.078A.247.247 0 0 1 7.15 0z"></path>
                      </svg>
                    </a>
                    <div className="bt-ccomp__content "
                      style={{ display: resourcesToggle ? "block" : "none" }}
                    >
                      <ul className="menu-list level-0">
                        <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                          <a className="menu-list__link" href="https://www.strockrealestate.com/resources/">
                            Additional Resources
                          </a>
                        </li>
                        <li className="menu-item menu-item-type-post_type menu-item-object-page ">
                          <a
                            className="menu-list__link"
                            href="https://www.strockrealestate.com/blog/"
                          >
                            Blog
                          </a>
                        </li>
                        <li className="menu-item menu-item-type-post_type menu-item-object-page ">
                          <a
                            className="menu-list__link"
                            href="https://www.strockrealestate.com/guides/"
                          >
                            Community Guides
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children bt-ccomp"
                    data-bt-ccomp="dropdown"
                  >
                    <a
                      className="menu-list__link"
                      href="https://www.strockrealestate.com/agents/"
                      data-bt-ccomp-trigger=""
                    >
                      Agents
                    </a>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page ">
                    <a
                      className="menu-list__link"
                      href="https://www.strockrealestate.com/contactus/"
                    >
                      Contact Us
                    </a>
                  </li>
                  <li
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children bt-ccomp"
                    data-bt-ccomp="dropdown"
                    onClick={toggleTestimonials}
                  >
                    <a
                      className="menu-list__link"
                      target="_blank"
                      data-bt-ccomp-trigger=""
                    >
                      Testimonials
                      <svg
                        viewBox="0 0 7.798 4.548"
                        id="bicon-arrow-down"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M7.15 0a.25.25 0 0 1 .18.078l.39.39a.25.25 0 0 1 .078.18.24.24 0 0 1-.078.18L4.08 4.47a.246.246 0 0 1-.36 0L.077.83A.247.247 0 0 1 .078.47l.39-.392A.255.255 0 0 1 .65 0c.07 0 .13.026.18.078l3.07 3.07L6.97.078A.247.247 0 0 1 7.15 0z"></path>
                      </svg>
                    </a>
                    <div className="bt-ccomp__content "
                      style={{ display: testimonialsToggle ? "block" : "none" }}
                    >
                      <ul className="menu-list level-0">
                        <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                          <a className="menu-list__link" href="https://www.strockrealestate.com/ben-strock-2/">
                            Ben Strock
                          </a>
                        </li>
                        <li className="menu-item menu-item-type-post_type menu-item-object-page ">
                          <a
                            className="menu-list__link"
                            href="https://www.strockrealestate.com/sarah-schneickert-2/"
                          >
                            Sarah Schneickert
                          </a>
                        </li>
                        <li className="menu-item menu-item-type-post_type menu-item-object-page ">
                          <a
                            className="menu-list__link"
                            href="https://www.strockrealestate.com/resources/spencer-hays-2/"
                          >
                            Spencer Hays
                          </a>
                        </li>
                        <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                          <a className="menu-list__link" href="https://www.strockrealestate.com/rose-wood-2/">
                            Rose Wood
                          </a>
                        </li>
                        <li className="menu-item menu-item-type-post_type menu-item-object-page ">
                          <a
                            className="menu-list__link"
                            href="https://www.strockrealestate.com/bjorn-berg/"
                          >
                            Bjorn Berg
                          </a>
                        </li>
                        <li className="menu-item menu-item-type-post_type menu-item-object-page ">
                          <a
                            className="menu-list__link"
                            href="https://www.strockrealestate.comresources/shiri-gradek/"
                          >
                            Shiri Gradek
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                    <a
                      className="menu-list__link"
                      target="_blank"
                      href="https://www.strockrealestate.com/contactus/"
                    >
                      Trade-Ins
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>
      </div>
      <div className="js-mobile-header__wrapper bt-header__mobile px-10--safe py-5 bt-header__mobile--tablet">
        <div className="grid grid--center grid--justifyBetween">
          <div className="cell">
            <a href="/" className="uk-display-inline-block">
              <img
                className="bt-inner-logo"
                src="https://bt-wpstatic.freetls.fastly.net/wp-content/blogs.dir/2137/files/2019/09/innerpage.png"
                alt="Stock Reale State Logo"
              />
            </a>
          </div>
          <div className="cell cell-xs-2 text-xs--right">
            <a
              className="bt-off-canvas__hamburger bt-off-canvas__trigger js-off-canvas__trigger at-menu-btn"
              onClick={toggleClass}
            >
              <i className="fas fa-fw fa-bars"></i>
            </a>
          </div>
        </div>
      </div>
      {/* MOBILE NAV */}
      <div
        className={isActive ? "mobile-container-active" : "mobile-container"}
      >
        <nav className="bt-off-canvas bt-off-canvas__common bt-off-canvas-main-menu js-hub">
          <a
            className="bt-off-canvas-menu__close js-off-canvas__close"
            onClick={toggleClass}
          >
            <i className="fas fa-fw fa-times-circle"></i>
          </a>
          <ul className="bt-nav-main">
            <li
              id="menu-item-8267"
              className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item "
            >
              <a href="https://www.strockrealestate.com/" className="p-15">
                Home
                </a>
            </li>
            <li
              id="menu-item-8766"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children bt-ccomp"
              data-bt-ccomp="toggle"
            >
              <a
                href="#"
                className="p-15"
                data-bt-ccomp-trigger=""
                onClick={toggleSearch}
              >
                Search
                  <svg
                  viewBox="0 0 7.798 4.548"
                  id="bicon-arrow-down-black"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7.15 0a.25.25 0 0 1 .18.078l.39.39a.25.25 0 0 1 .078.18.24.24 0 0 1-.078.18L4.08 4.47a.246.246 0 0 1-.36 0L.077.83A.247.247 0 0 1 .078.47l.39-.392A.255.255 0 0 1 .65 0c.07 0 .13.026.18.078l3.07 3.07L6.97.078A.247.247 0 0 1 7.15 0z"></path>
                </svg>
              </a>
              <div
                className={
                  "bt-ccomp__content px-15--safe " +
                  (searchToggle ? "mobile-aditional-open" : " ")
                }
              >
                <ul className="bt-off-canvas__sub-menu level-0">
                  <li
                    id="menu-item-8269"
                    className="menu-item menu-item-type-custom menu-item-object-custom "
                  >
                    <a
                      className="p-15"
                      href="https://www.strockrealestate.com/results-gallery/"
                    >
                      Search
                      </a>
                  </li>
                  <li
                    id="menu-item-8767"
                    className="menu-item menu-item-type-post_type menu-item-object-page "
                  >
                    <a
                      href="https://www.strockrealestate.com/result-map/"
                      className="p-15"
                    >
                      Map Search
                      </a>
                  </li>
                  <li
                    id="menu-item-8768"
                    className="menu-item menu-item-type-post_type menu-item-object-page "
                  >
                    <a
                      href="https://www.strockrealestate.com/results-gallery/"
                      className="p-15"
                    >
                      Our Listings
                      </a>
                  </li>
                </ul>
              </div>
            </li>
            <li
              id="menu-item-8267"
              className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item "
            >
              <a href="https://www.lydiagable.com/finance/" className="p-15">
                Financing
              </a>
            </li>
            <li
              id="menu-item-8267"
              className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item "
            >
              <a href="https://www.lydiagable.com/buy/" className="p-15">
                Buying
                </a>
            </li>
            <li
              id="menu-item-8267"
              className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item "
            >
              <a href="https://www.lydiagable.com/sell/" className="p-15">
                Selling
              </a>
            </li>
            <li
              id="menu-item-8274"
              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children bt-ccomp"
              data-bt-ccomp="toggle"
            >
              <a
                href="#"
                className="p-15"
                data-bt-ccomp-trigger=""
                onClick={toggleResources}
              >
                Resources
                  <svg
                  viewBox="0 0 7.798 4.548"
                  id="bicon-arrow-down-black"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7.15 0a.25.25 0 0 1 .18.078l.39.39a.25.25 0 0 1 .078.18.24.24 0 0 1-.078.18L4.08 4.47a.246.246 0 0 1-.36 0L.077.83A.247.247 0 0 1 .078.47l.39-.392A.255.255 0 0 1 .65 0c.07 0 .13.026.18.078l3.07 3.07L6.97.078A.247.247 0 0 1 7.15 0z"></path>
                </svg>
              </a>
              <div
                className={
                  "bt-ccomp__content px-15--safe " +
                  (resourcesToggle ? "mobile-aditional-open" : " ")
                }
              >
                <ul className="bt-off-canvas__sub-menu level-0">
                  <li
                    id="menu-item-8685"
                    className="menu-item menu-item-type-post_type menu-item-object-page "
                  >
                    <a
                      href="https://www.strockrealestate.com/resources/"
                      className="p-15"
                    >
                      Additional Resources
                      </a>
                  </li>
                  <li
                    id="menu-item-9166"
                    className="menu-item menu-item-type-custom menu-item-object-custom "
                  >
                    <a
                      target="_blank"
                      href="https://www.strockrealestate.com/blog/"
                      className="p-15"
                    >
                      Blog
                      </a>
                  </li>
                  <li
                    id="menu-item-8685"
                    className="menu-item menu-item-type-post_type menu-item-object-page "
                  >
                    <a
                      href="https://www.strockrealestate.com/guides/"
                      className="p-15"
                    >
                      Community Guides
                      </a>
                  </li>
                 
                  
                </ul>
              </div>
            </li>
            <li
              id="menu-item-8267"
              className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item "
            >
              <a href="https://www.strockrealestate.com/agents/" className="p-15">
                Agents
                </a>
            </li>
            <li
              id="menu-item-8267"
              className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item "
            >
              <a href="https://www.strockrealestate.com/contactus/" className="p-15">
                Contact Us
                </a>
            </li>
            <li
              id="menu-item-8274"
              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children bt-ccomp"
              data-bt-ccomp="toggle"
            >
              <a
                href="#"
                className="p-15"
                data-bt-ccomp-trigger=""
                onClick={toggleTestimonials}
              >
                Testimonials
                  <svg
                  viewBox="0 0 7.798 4.548"
                  id="bicon-arrow-down-black"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7.15 0a.25.25 0 0 1 .18.078l.39.39a.25.25 0 0 1 .078.18.24.24 0 0 1-.078.18L4.08 4.47a.246.246 0 0 1-.36 0L.077.83A.247.247 0 0 1 .078.47l.39-.392A.255.255 0 0 1 .65 0c.07 0 .13.026.18.078l3.07 3.07L6.97.078A.247.247 0 0 1 7.15 0z"></path>
                </svg>
              </a>
              <div
                className={
                  "bt-ccomp__content px-15--safe " +
                  (testimonialsToggle ? "mobile-aditional-open" : " ")
                }
              >
                <ul className="bt-off-canvas__sub-menu level-0">
                  <li
                    id="menu-item-8685"
                    className="menu-item menu-item-type-post_type menu-item-object-page "
                  >
                    <a
                      href="https://www.strockrealestate.com/ben-strock-2/"
                      className="p-15"
                    >
                      Ben Strock
                      </a>
                  </li>
                  <li
                    id="menu-item-9166"
                    className="menu-item menu-item-type-custom menu-item-object-custom "
                  >
                    <a
                      target="_blank"
                      href="https://www.strockrealestate.com/sarah-schneickert-2/"
                      className="p-15"
                    >
                      Sarah Schneickert
                      </a>
                  </li>
                  <li
                    id="menu-item-8685"
                    className="menu-item menu-item-type-post_type menu-item-object-page "
                  >
                    <a
                      href="https://www.strockrealestate.com/spencer-hays-2/"
                      className="p-15"
                    >
                      Spencer Hays
                      </a>
                  </li>
                  <li
                    id="menu-item-8685"
                    className="menu-item menu-item-type-post_type menu-item-object-page "
                  >
                    <a
                      href="https://www.strockrealestate.com/spencer-hays-2/"
                      className="p-15"
                    >
                      Rose Wood
                      </a>
                  </li>
                  <li
                    id="menu-item-8685"
                    className="menu-item menu-item-type-post_type menu-item-object-page "
                  >
                    <a
                      href="https://www.strockrealestate.com/spencer-hays-2/"
                      className="p-15"
                    >
                      Bjor Berg
                      </a>
                  </li>
                </ul>
              </div>
            </li>
            
            
            <li
              id="menu-item-9513"
              className="menu-item menu-item-type-post_type menu-item-object-page "
            >
              <a
                href="https://www.strockrealestate.com/contactus/"
                className="p-15"
              >
                Trade-Ins
                </a>
            </li>
          

          </ul>
        </nav>
      </div>
    </div>
  );
};

HeaderContainer.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.any,
  }),
};

HeaderContainer.defaultProps = { location: { pathname: '' } };

export default memo(HeaderContainer);
